import { Button, Link } from "@mui/material";
import { C } from "../../common/theme";
import { Banner } from "../../ui";

/** Brevo only answers servers on its authorised IP list. */
export default function BrevoErrorAlert({ message, onRetry }: { message: string; onRetry: () => void }) {
  const ip = message.match(/\d{1,3}(\.\d{1,3}){3}/)?.[0];
  return (
    <Banner
      tone="warning"
      title="Brevo is refusing this server"
      action={
        <Button variant="outlined" size="small" onClick={onRetry}>
          Retry
        </Button>
      }
    >
      {" "}
      Add {ip ? <b>{ip}</b> : "the admin server's IP"} to{" "}
      <Link href="https://app.brevo.com/security/authorised_ips" target="_blank" rel="noreferrer" sx={{ color: C.ink, fontWeight: 600 }}>
        Brevo → Security → Authorised IPs
      </Link>
      , then retry.
    </Banner>
  );
}
